import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=24986052"
import script from "./AccountList.vue?vue&type=script&lang=js"
export * from "./AccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports